import { render, staticRenderFns } from "./FnRoom.vue?vue&type=template&id=2dbd84eb&scoped=true"
import script from "./FnRoom.vue?vue&type=script&lang=js"
export * from "./FnRoom.vue?vue&type=script&lang=js"
import style0 from "./FnRoom.vue?vue&type=style&index=0&id=2dbd84eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd84eb",
  null
  
)

export default component.exports